module.exports = __webpack_public_path__ + "img/roadmap.961cc29e.svg";